import React from "react";
import "./OnasBlock.scss";

import { withTranslation } from "../../../../i18n";
import Head from "next/head";

import PhoneIcon from "../../../../public/images/phone_black.svg";

const OnasBlock = ({ t }) => {
    return (
        <div className="o_nas_wrapper">
            <Head>
                <title>{t("О нас")} │ PRORAB</title>
            </Head>
            <h1 className="title">{t("О нас")}</h1>
            <div className="text">
                <span>
                    {t("Компания PRORAB занимается дистрибуцией и продажей товаров для DIY сегмента с 2013 года")}.
                </span>
                <span>
                    {t(
                        "В активах компании находятся 2 розничных мини-маркета и 2 склада, которые позволяют сократить время и затраты на перевоз товаров по"
                    )}{" "}
                    {t("г")}. Полтава.{" "}
                    {t(
                        "Так же, компания предоставляет услугу доставки заказов по всей территории Украины, с помощью почтовых операторов"
                    )}
                            .
                </span>
                <span>
                    {t(
                        "Для розничных клиентов, предоставляется индивидуальная система скидок, программа лояльности, а также специальные предложения"
                    )}
                    .
                </span>
                <span>
                    {t("Для предприятий разработаны комплексные решения для строительства и ремонта объектов")}.
                </span>
                <span>
                    {t(
                        "Широкая ассортиментная линейка строительных инструментов и материалов, удобная система оплаты, оперативность и качественная комплектация заказов позволяют нашим клиентам быстро найти и приобрести нужный товар по лучшим ценам"
                    )}
                    .
                </span>

                {/* <span>Магазин №1</span>
                <div className="phone_address">
                    <img src={PhoneIcon} alt="телефон" width="32px" height="32px"/>
                    <span className="phone_address__text">
                        <a className="phone_address__link" href="tel:+380977730444" rel="nofollow">+380 97 773 04 44</a>
                        <i>{t("г Полтава просп Мира, 36")}</i>
                    </span>
                </div>

                <span>Магазин №2</span>
                <div className="phone_address">
                    <img src={PhoneIcon} alt="телефон" width="32px" height="32px"/>
                    <span className="phone_address__text">
                        <a className="phone_address__link" href="tel:+380997730444" rel="nofollow">+38099 773 04 44</a>
                        <i>{t("г Полтава, ул Полтавская, 1")}</i>
                    </span>
                </div> */}
            </div>
        </div>
    );
};

export default withTranslation("infoPages")(OnasBlock);
